import React, { useState, useEffect } from 'react';
import styled from "styled-components";
import {
  FaUser, FaGlobe, FaWrench, FaSignOutAlt, FaServer, FaClock,
  FaTasks, FaCar, FaExclamationTriangle, FaCrown, FaRegClock,
  FaFilePdf, FaCalendarAlt, FaPrint, FaLink, FaExternalLinkAlt,
  FaBars, FaTimes, FaFileInvoiceDollar, FaFileSignature, FaFileContract, FaFileAlt, FaUpload, FaExchangeAlt, FaFolderOpen
} from "react-icons/fa";
import { IoMdBusiness } from "react-icons/io";
import { DiAptana } from "react-icons/di";
import axios from 'axios';
import { decodeToken } from "react-jwt";
import Header from '../others/Header';
import { useNavigate } from 'react-router-dom';
import { isExpired } from "react-jwt";
import config from '../config/config';
import Modal from 'react-modal';
import { useToast } from '../components/ToastContext';
import { useTour } from '../components/TourContext';
import { carregarLogoEmpresa } from '../others/logoEmpresa';
import LogoEnquadrado from '../components/LogoEnquadrado';

Modal.setAppElement('#root');

const saudacao = (data) => {
  const hora = data.getHours();
  if (hora >= 5 && hora < 12) return 'Bom dia';
  if (hora >= 12 && hora < 18) return 'Boa tarde';
  return 'Boa noite';
};

const primeiroNome = (nome) => (nome || '').trim().split(/\s+/)[0] || 'usuário';

// "Sábado, 3 de outubro de 2026"
const dataPorExtenso = (data) => {
  const texto = data.toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  return texto.charAt(0).toUpperCase() + texto.slice(1);
};

const Home = () => {
  const navigate = useNavigate();
  const [canRender, setCanRender] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [formErrors, setFormErrors] = useState({});
  const [userData, setUserData] = useState(null);
  const { API_BASE_URL } = config;

  const { addToast } = useToast();
  const { verificarPrimeiroAcesso } = useTour();
  const [usefulLinks, setUsefulLinks] = useState([]);
  const [lembretesHoje, setLembretesHoje] = useState([]);
  const [agora, setAgora] = useState(() => new Date());
  // Logo da empresa no centro (Configurações): sem ele, ou se falhar, fica o logo do sistema
  const [logoEmpresa, setLogoEmpresa] = useState({ temLogo: false, url: null, ajuste: null });

  useEffect(() => {
    let url = null;
    let cancelado = false;
    carregarLogoEmpresa()
      .then((logo) => { url = logo.url; if (!cancelado) setLogoEmpresa(logo); })
      .catch(() => {});
    return () => { cancelado = true; if (url) URL.revokeObjectURL(url); };
  }, []);

  // Relógio do card de boas-vindas (data e hora); atualiza a cada 30s, o suficiente para os minutos
  useEffect(() => {
    const timer = setInterval(() => setAgora(new Date()), 30000);
    return () => clearInterval(timer);
  }, []);

  // Detecta se é desktop para abrir sidebar por padrão
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setSidebarOpen(true);
      } else {
        setSidebarOpen(false);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    loadUsefulLinks();
  }, []);

  const loadUsefulLinks = async () => {
    try {
      const token = localStorage.getItem('jwtToken');
      const response = await axios.get(`${API_BASE_URL}/links`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setUsefulLinks(response.data);
    } catch (error) {
      console.error('Erro ao carregar links úteis:', error);
    }
  };

  const getAuthHeader = () => {
    const token = localStorage.getItem('jwtToken');
    return {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    };
  };

  useEffect(() => {
    const token = localStorage.getItem("jwtToken");
    if (token === null || typeof token === "undefined" || isExpired(token)) {
      window.location.href = "/login";
    } else {
      const decoded = decodeToken(token);
      setUserData(decoded);
      if (decoded?.needUpdatePass) {
        setShowModal(true);
      }
      verificarPrimeiroAcesso(decoded?.sub);
      setCanRender(true);
    }
  }, []);

  // ── Lembretes da Agenda para hoje. A data é a LOCAL do usuário (toISOString() usa UTC e, à noite, viraria amanhã).
  // GET /agenda/dia/{AAAA-MM-DD}
  useEffect(() => {
    if (!canRender) return;
    const h = new Date();
    const hoje = `${h.getFullYear()}-${String(h.getMonth() + 1).padStart(2, '0')}-${String(h.getDate()).padStart(2, '0')}`;
    const carregarLembretesHoje = async () => {
      try {
        const token = localStorage.getItem('jwtToken');
        const response = await axios.get(`${API_BASE_URL}/agenda/dia/${hoje}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        // Concluídos não aparecem na Home (continuam na tela da Agenda)
        setLembretesHoje((response.data || []).filter(l => !l.concluido));
      } catch (error) {
        console.error('Erro ao carregar lembretes de hoje:', error);
      }
    };
    carregarLembretesHoje();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canRender]);

  // X no compromisso: marca como feito e tira da Home na hora; se a API falhar, ele volta para a lista
  // PUT /agenda/{id}/concluido
  const concluirLembrete = async (lembrete) => {
    setLembretesHoje(lista => lista.filter(l => l.idLembrete !== lembrete.idLembrete));
    try {
      const token = localStorage.getItem('jwtToken');
      await axios.put(`${API_BASE_URL}/agenda/${lembrete.idLembrete}/concluido`, { concluido: true }, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      addToast('success', 'Compromisso concluído!');
    } catch (error) {
      console.error('Erro ao concluir lembrete:', error);
      addToast('error', error.response?.data?.message || 'Erro ao concluir o compromisso');
      setLembretesHoje(lista => [...lista, lembrete].sort(
        (a, b) => (a.horaLembrete || '99:99').localeCompare(b.horaLembrete || '99:99') || a.idLembrete - b.idLembrete
      ));
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('jwtToken');
    navigate('/login');
  };

  const handleFormChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.currentPassword) errors.currentPassword = "A senha atual é obrigatória.";
    if (!formData.newPassword) {
      errors.newPassword = "A nova senha é obrigatória.";
    } else if (formData.newPassword.length < 10) {
      errors.newPassword = "A senha deve ter no mínimo 10 caracteres.";
    } else if (!/(?=.*[a-zA-Z])/.test(formData.newPassword)) {
      errors.newPassword = "A senha deve conter pelo menos uma letra.";
    } else if (!/(?=.*\d)/.test(formData.newPassword)) {
      errors.newPassword = "A senha deve conter pelo menos um número.";
    } else if (!/(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])/.test(formData.newPassword)) {
      errors.newPassword = "A senha deve conter pelo menos um caractere especial.";
    }
    if (!formData.confirmPassword) {
      errors.confirmPassword = "A confirmação de senha é obrigatória.";
    } else if (formData.newPassword !== formData.confirmPassword) {
      errors.confirmPassword = "As senhas não coincidem.";
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("jwtToken");
    if (validateForm()) {
      try {
        const response = await fetch(`${API_BASE_URL}/usuarios/updatePassword`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(formData)
        });
        if (response.status === 401) {
          const errorMessage = await response.text();
          setFormErrors({ currentPassword: errorMessage });
        } else if (response.ok) {
          const data = await response.json();
          localStorage.setItem("jwtToken", data.token);
          setShowModal(false);
          const decoded = decodeToken(data.token);
          setUserData(decoded);
          // Com senha provisória a API recusava os links; agora que a senha foi trocada, carrega de novo
          loadUsefulLinks();
        } else {
          console.error('Erro ao atualizar senha');
        }
      } catch (error) {
        console.error('Erro de rede', error);
      }
    }
  };

  const formatarTipoPlano = (tipo) => {
    switch (tipo) {
      case 'TESTE': return 'Plano Teste';
      case 'DEFINITIVO': return 'Plano Definitivo';
      case 'MENSAL': return 'Plano Mensal';
      default: return tipo;
    }
  };

  const getPlanoIcon = (tipo) => {
    switch (tipo) {
      case 'TESTE': return <FaRegClock size={14} />;
      case 'DEFINITIVO': return <FaCrown size={14} />;
      case 'MENSAL': return <FaCrown size={14} />;
      default: return <FaCrown size={14} />;
    }
  };


  // ─── Itens do menu lateral — ordem definida pelo cliente ────────────────────
  const menuItems = [
    { id: 'ordemServico', label: 'Ordem de Serviço',    icon: <FaTasks size={20} />,      path: '/ordemServico' },
    { id: 'clientes',     label: 'Clientes e Veículos', icon: <FaCar size={20} />,         path: '/Clientes' },
    // ── NOVO: Importar CRLV-e em lote — cadastra os veículos nos clientes a partir dos documentos
    { id: 'importarCrlv', label: 'Importar CRLV-e',      icon: <FaUpload size={20} />,      path: '/importar-crlv' },
    // ── NOVO: Processos — documentos dos processos guardados e pesquisáveis (placa, chassi, cliente)
    { id: 'processos',    label: 'Processos',            icon: <FaFolderOpen size={20} />,  path: '/processos' },
    // ── NOVO: Procuração de Veículo — logo abaixo de Clientes e Veículos
    { id: 'procuracao',   label: 'Procuração de Veículo', icon: <FaFileSignature size={20} />, path: '/procuracao' },
    // ── NOVO: Contratos — logo abaixo de Procuração de Veículo
    { id: 'contratos',    label: 'Contratos',            icon: <FaFileContract size={20} />, path: '/contratos' },
    // ── NOVO: Documentos Complementares — logo abaixo de Contratos
    { id: 'documentosComplementares', label: 'Documentos Complementares', icon: <FaFileAlt size={20} />, path: '/documentos-complementares' },
    ...(userData?.tipoUsuario !== 'FUNCIONARIO' ? [
      { id: 'relatorio',  label: 'Relatório de Caixa',  icon: <FaFilePdf size={20} />,     path: '/relatorios' },
    ] : []),
    { id: 'servicos',     label: 'Serviços',             icon: <FaWrench size={20} />,      path: '/cadastroServico' },
    // ── NOVO: Despesas — visível para GERENTE e MANAGER
    ...(['GERENTE', 'MANAGER'].includes(userData?.tipoUsuario) ? [
      { id: 'despesas',   label: 'Despesas',            icon: <FaFileInvoiceDollar size={20} />, path: '/despesas' },
    ] : []),
    // ── NOVO: Agenda — logo abaixo de Despesas, visível para todos os perfis
    { id: 'agenda',       label: 'Agenda',               icon: <FaCalendarAlt size={20} />, path: '/agenda' },
    ...(userData?.tipoUsuario !== 'FUNCIONARIO' ? [
      { id: 'usuarios',   label: 'Usuários',             icon: <FaUser size={20} />,        path: '/usuarios' },
      { id: 'config',     label: 'Configurações',        icon: <DiAptana size={20} />,      path: '/settings' },
    ] : []),
    ...(userData?.tipoUsuario === 'MANAGER' ? [
      // ── NOVO: Manager escolhe com qual empresa trabalhar (só vê os dados dela)
      { id: 'trocarEmpresa', label: 'Trocar Empresa',     icon: <FaExchangeAlt size={20} />, path: '/selecionar-empresa' },
      { id: 'empresas',   label: 'Empresas',             icon: <IoMdBusiness size={20} />,  path: '/cadastroEmpresas' },
      { id: 'servidor',   label: 'Servidor',             icon: <FaServer size={20} />,      path: '/server-info' },
      { id: 'backups',    label: 'Backups/CRONS',        icon: <FaClock size={20} />,       path: '/backups-crons' },
    ] : []),
  ];

  const handleMenuItemClick = (e, item) => {
    // Ctrl/Shift/Cmd+clique e botão do meio: deixa o navegador abrir o link em nova aba/janela
    if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    if (item.onClick) {
      item.onClick();
    } else if (item.path) {
      window.location.href = item.path;
    }
    if (window.innerWidth < 1024) {
      setSidebarOpen(false);
    }
  };

  return (
    <HomeBackground>
      {canRender && userData && (
        <HomeContainer>

          {/* ── Top Bar ─────────────────────────────────────────────────────── */}
          <TopBar>
            <TopBarContent>
              <MenuToggleButton onClick={() => setSidebarOpen(!sidebarOpen)}>
                {sidebarOpen ? <FaTimes size={18} /> : <FaBars size={18} />}
              </MenuToggleButton>

              <LeftSection>
                {/* Só o escudo: a imagem completa (com o nome e o copyright) fica ilegível neste tamanho */}
                <CompanyLogo>
                  <img src="/logo_nexus_escudo.png" alt="Nexus Despachante" />
                </CompanyLogo>
                <CompanyInfo>
                  <CompanyName>{userData.empresaNomeFantasia || userData.empresaRazaoSocial || 'Nexus Despachante'}</CompanyName>
                  <CompanySubtitle>Nexus Despachante - Sistema de Gestão</CompanySubtitle>
                </CompanyInfo>
              </LeftSection>

              <RightSection>
                <UserSection>
                  <UserWelcome>
                    <UserAvatar>
                      <FaUser size={14} color="#fff" />
                    </UserAvatar>
                    <UserDetails>
                      <UserName>{userData.nomeUsuario}</UserName>
                      <UserRole>{(userData.tipoUsuario === 'FUNCIONARIO' ? 'COLABORADOR' : userData.tipoUsuario) || 'Usuário'}</UserRole>
                    </UserDetails>
                  </UserWelcome>

                  <LogoutButton onClick={handleLogout}>
                    <FaSignOutAlt size={13} />
                    <span>Sair</span>
                  </LogoutButton>
                </UserSection>

                <PlanInfoContainer>
                  <PlanLabel>Plano Atual:</PlanLabel>
                  <PlanInfoWrapper>
                    <PlanContainer>
                      <PlanIconContainer tipoPlano={userData.empresaTipoPlano}>
                        {getPlanoIcon(userData.empresaTipoPlano)}
                      </PlanIconContainer>
                      <PlanText tipoPlano={userData.empresaTipoPlano}>
                        {formatarTipoPlano(userData.empresaTipoPlano)}
                      </PlanText>
                    </PlanContainer>
                    {userData.empresaTipoPlano === 'TESTE' && userData.empresaDiasRestantes && (
                      <TestDaysWarning>
                        <FaExclamationTriangle size={11} />
                        <span>{userData.empresaDiasRestantes} dias restantes</span>
                      </TestDaysWarning>
                    )}
                  </PlanInfoWrapper>
                </PlanInfoContainer>
              </RightSection>
            </TopBarContent>
          </TopBar>

          {/* ── Main (sidebar + content) ────────────────────────────────────── */}
          <MainContent>
            {sidebarOpen && <SidebarOverlay onClick={() => setSidebarOpen(false)} />}

            <Sidebar isOpen={sidebarOpen}>
              <SidebarHeader>
                <SidebarTitle>Menu</SidebarTitle>
                <SidebarCloseBtn onClick={() => setSidebarOpen(false)}>
                  <FaTimes size={16} />
                </SidebarCloseBtn>
              </SidebarHeader>
              <SidebarNav>
                {menuItems.map((item) => (
                  <SidebarItem key={item.id} href={item.path} onClick={(e) => handleMenuItemClick(e, item)}>
                    <IconWrapper>{item.icon}</IconWrapper>
                    <ItemLabel>{item.label}</ItemLabel>
                  </SidebarItem>
                ))}

                {usefulLinks.length > 0 && (
                  <SidebarLinksSection>
                    <SidebarLinksTitle>
                      <FaLink size={12} style={{ marginRight: '6px' }} />
                      Links Úteis
                    </SidebarLinksTitle>
                    {usefulLinks.map((link, index) => (
                      <SidebarLinkItem
                        key={index}
                        accentColor={link.color || '#20b2aa'}
                        // Só abre endereços web (um "javascript:" salvo antes da validação no back rodaria com o login do usuário)
                        onClick={() => { if (/^https?:\/\//i.test(link.url || '')) window.open(link.url, '_blank', 'noopener'); }}
                      >
                        <FaGlobe size={14} style={{ flexShrink: 0, opacity: 0.85 }} />
                        <SidebarLinkText>
                          <span>{link.title}</span>
                          <small>{link.url}</small>
                        </SidebarLinkText>
                        <FaExternalLinkAlt size={10} style={{ flexShrink: 0, opacity: 0.6 }} />
                      </SidebarLinkItem>
                    ))}
                  </SidebarLinksSection>
                )}
              </SidebarNav>
            </Sidebar>

            <ContentArea>
              <WelcomeMessage>
                <div>
                  <h1>{saudacao(agora)}, {primeiroNome(userData.nomeUsuario)}</h1>
                  <p>Bem-vindo à Nexus Despachante. Selecione uma opção no menu para começar.</p>
                </div>
                <DateBadge>
                  <FaCalendarAlt size={13} />
                  <span>{dataPorExtenso(agora)}</span>
                  <DateTime>{agora.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}</DateTime>
                </DateBadge>
              </WelcomeMessage>

              {/* ── Logo + agenda do dia: com compromissos hoje, o logo encolhe e a agenda ocupa a direita,
                  em ordem de horário (o back já devolve ordenado). No celular a agenda vem acima do logo. */}
              <HomeBody>
                {/* Logo próprio: ocupa o cartão com o enquadramento salvo em Configurações; sem ele, o do sistema */}
                <LogoSection $personalizado={!!logoEmpresa.url}>
                  {logoEmpresa.url ? (
                    <LogoEnquadrado url={logoEmpresa.url} ajuste={logoEmpresa.ajuste}
                      alt={userData.empresaNomeFantasia || 'Logo da empresa'} />
                  ) : (
                    <LogoContainer>
                      <LogoImage src="/logodesp.jpg" alt="Nexus Despachante" />
                    </LogoContainer>
                  )}
                </LogoSection>

                {lembretesHoje.length > 0 && (
                  <AgendaPanel>
                    <AgendaHeader>
                      <FaCalendarAlt size={15} />
                      <span>Agenda de hoje</span>
                      <AgendaCount>{lembretesHoje.length}</AgendaCount>
                    </AgendaHeader>
                    <AgendaList>
                      {lembretesHoje.map((lembrete) => (
                        <AgendaItem key={lembrete.idLembrete} onClick={() => navigate('/agenda')} title="Abrir na Agenda">
                          <AgendaHora>{lembrete.horaLembrete || '--:--'}</AgendaHora>
                          <AgendaItemBody>
                            <strong>{lembrete.titulo}</strong>
                            {/* Com quem é o compromisso (Agenda -> Cliente) */}
                            {lembrete.nomeCliente && (
                              <span className="cliente"><FaUser size={10} /> {lembrete.nomeCliente}</span>
                            )}
                            {lembrete.observacoes && <p>{lembrete.observacoes}</p>}
                          </AgendaItemBody>
                          <AgendaDoneButton
                            type="button"
                            title="Já foi feito — tirar da tela"
                            aria-label={`Concluir ${lembrete.titulo}`}
                            onClick={(e) => { e.stopPropagation(); concluirLembrete(lembrete); }}
                          >
                            <FaTimes size={11} />
                          </AgendaDoneButton>
                        </AgendaItem>
                      ))}
                    </AgendaList>
                  </AgendaPanel>
                )}
              </HomeBody>
            </ContentArea>
          </MainContent>

          {/* ── Modal Senha ─────────────────────────────────────────────────── */}
          <Modal
            isOpen={showModal}
            style={{
              overlay: { backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 1000 },
              content: {
                top: '50%', left: '50%', right: 'auto', bottom: 'auto',
                marginRight: '-50%', transform: 'translate(-50%,-50%)',
                maxWidth: '500px', width: '90%', padding: '40px',
                borderRadius: '15px', border: 'none',
                boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
                background: 'linear-gradient(135deg,#ffffff 0%,#f8f9fa 100%)'
              },
            }}
            shouldCloseOnOverlayClick={false}
          >
            <ModalHeader>
              <h2 style={{ color: '#2c3e50', margin: 0 }}>Atualização de Senha Obrigatória</h2>
              <SecurityIcon>
                <FaExclamationTriangle size={20} color="#e74c3c" />
              </SecurityIcon>
            </ModalHeader>

            <PasswordRequirements>
              <h4 style={{ margin: '15px 0 10px 0', color: '#2c3e50' }}>Requisitos da senha:</h4>
              <ul style={{ paddingLeft: '20px', margin: 0, color: '#7f8c8d' }}>
                <li>Mínimo de 10 caracteres</li>
                <li>Pelo menos uma letra</li>
                <li>Pelo menos um número</li>
                <li>Pelo menos um caractere especial (!@#$%^&* etc.)</li>
              </ul>
            </PasswordRequirements>

            <form onSubmit={handleSubmit}>
              <FormField>
                <label>Senha atual:</label>
                <PasswordInput type="password" name="currentPassword" value={formData.currentPassword}
                  onChange={handleFormChange} hasError={!!formErrors.currentPassword}
                  placeholder="Digite sua senha atual" required />
                {formErrors.currentPassword && <ErrorMessage>{formErrors.currentPassword}</ErrorMessage>}
              </FormField>
              <FormField>
                <label>Nova senha:</label>
                <PasswordInput type="password" name="newPassword" value={formData.newPassword}
                  onChange={handleFormChange} hasError={!!formErrors.newPassword}
                  placeholder="Digite sua nova senha" required />
                {formErrors.newPassword && <ErrorMessage>{formErrors.newPassword}</ErrorMessage>}
              </FormField>
              <FormField>
                <label>Confirmar nova senha:</label>
                <PasswordInput type="password" name="confirmPassword" value={formData.confirmPassword}
                  onChange={handleFormChange} hasError={!!formErrors.confirmPassword}
                  placeholder="Confirme sua nova senha" required />
                {formErrors.confirmPassword && <ErrorMessage>{formErrors.confirmPassword}</ErrorMessage>}
              </FormField>
              <ButtonContainer>
                <SubmitButton type="submit">Atualizar Senha</SubmitButton>
              </ButtonContainer>
            </form>
          </Modal>

        </HomeContainer>
      )}
    </HomeBackground>
  );
};

// ─── ESTILOS — visual NEXUS CRVA com identidade Nexus Despachante ────────────
// Paleta: verde-escuro #004d4d · teal #008080 · teal-claro #20b2aa
//         vermelho logo #c0392b · fundo #e6f7f5

const HomeBackground = styled.div`
  background: linear-gradient(135deg, #e6f7f5 0%, #d4efed 100%);
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow-x: hidden;
`;

const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1600px;
  padding: 20px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 10px;
  }

  @media (max-width: 480px) {
    padding: 8px;
  }
`;

// ── Top Bar ──────────────────────────────────────────────────────────────────
const TopBar = styled.div`
  width: 100%;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 15px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  margin-bottom: 20px;
  border: 1px solid rgba(0,0,0,0.05);
  overflow: hidden;
`;

const TopBarContent = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 20px;
  gap: 12px;
  box-sizing: border-box;
  flex-wrap: nowrap;
  overflow: hidden;
  min-width: 0;

  @media (max-width: 600px) {
    padding: 10px 12px;
    gap: 8px;
  }

  @media (max-width: 360px) {
    padding: 8px;
    gap: 6px;
  }
`;

const MenuToggleButton = styled.button`
  background: linear-gradient(135deg, #008080 0%, #20b2aa 100%);
  border: none;
  color: white;
  width: 38px;
  height: 38px;
  min-width: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(0,128,128,0.4);
  }
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
`;

// Escudo da Nexus (fundo transparente): inteiro, sem cortar
const CompanyLogo = styled.div`
  width: 60px;
  height: 56px;
  min-width: 60px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: drop-shadow(0 2px 4px rgba(0,0,0,0.15));
  }

  @media (max-width: 480px) {
    width: 44px;
    height: 40px;
    min-width: 44px;
  }
`;

const CompanyInfo = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

const CompanyName = styled.h2`
  margin: 0;
  color: #2c3e50;
  font-size: 1.2rem;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 260px;

  @media (max-width: 768px) {
    font-size: 1rem;
    max-width: 160px;
  }

  @media (max-width: 480px) {
    font-size: 0.9rem;
    max-width: 110px;
  }
`;

const CompanySubtitle = styled.p`
  margin: 3px 0 0 0;
  color: #7f8c8d;
  font-size: 0.75rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 480px) {
    display: none;
  }
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
  flex-wrap: nowrap;

  @media (max-width: 600px) {
    gap: 8px;
  }
`;

const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
`;

const UserWelcome = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

const UserAvatar = styled.div`
  width: 34px;
  height: 34px;
  min-width: 34px;
  border-radius: 50%;
  background: linear-gradient(135deg, #008080 0%, #20b2aa 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 3px 10px rgba(0,128,128,0.3);
  flex-shrink: 0;
`;

const UserDetails = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;

  @media (max-width: 480px) {
    display: none;
  }
`;

const UserName = styled.span`
  font-weight: 600;
  color: #2c3e50;
  font-size: 0.82rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px;

  @media (max-width: 768px) {
    max-width: 80px;
  }
`;

const UserRole = styled.span`
  color: #7f8c8d;
  font-size: 0.68rem;
  font-weight: 500;
  white-space: nowrap;
`;

const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
  color: white;
  border: none;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.78rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 3px 10px rgba(231,76,60,0.3);
  white-space: nowrap;
  flex-shrink: 0;

  span {
    @media (max-width: 480px) {
      display: none;
    }
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(231,76,60,0.4);
  }
`;

const PlanInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
  flex-shrink: 0;

  @media (max-width: 600px) {
    display: none;
  }
`;

const PlanInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
`;

const PlanLabel = styled.span`
  font-size: 0.62rem;
  color: #7f8c8d;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
`;

const PlanContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  background: #f8f9fa;
  border-radius: 10px;
  border: 1px solid #e9ecef;
  white-space: nowrap;
`;

const PlanIconContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => {
    switch (props.tipoPlano) {
      case 'TESTE': return '#f39c12';
      case 'DEFINITIVO': return '#27ae60';
      case 'MENSAL': return '#008080';
      default: return '#7f8c8d';
    }
  }};
`;

const PlanText = styled.span`
  font-size: 0.78rem;
  font-weight: 600;
  color: ${props => {
    switch (props.tipoPlano) {
      case 'TESTE': return '#f39c12';
      case 'DEFINITIVO': return '#27ae60';
      case 'MENSAL': return '#008080';
      default: return '#7f8c8d';
    }
  }};
  white-space: nowrap;
`;

const TestDaysWarning = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: #e74c3c;
  font-weight: 600;
  font-size: 0.68rem;
  padding: 2px 8px;
  background: rgba(231,76,60,0.1);
  border-radius: 8px;
  white-space: nowrap;
  svg { flex-shrink: 0; }
`;

// ── Layout Principal ──────────────────────────────────────────────────────────
const MainContent = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  min-height: calc(100vh - 140px);
  position: relative;
  align-items: flex-start;
  overflow-x: hidden;
  box-sizing: border-box;

  @media (max-width: 1023px) {
    gap: 0;
  }
`;

const SidebarOverlay = styled.div`
  display: none;

  @media (max-width: 1023px) {
    display: block;
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0,0,0,0.4);
    z-index: 99;
  }
`;

const Sidebar = styled.aside`
  flex-shrink: 0;
  width: ${props => props.isOpen ? '260px' : '0px'};
  min-width: ${props => props.isOpen ? '260px' : '0px'};
  max-width: ${props => props.isOpen ? '260px' : '0px'};
  overflow: hidden;
  background: linear-gradient(160deg, #004d4d 0%, #008080 100%);
  border-radius: ${props => props.isOpen ? '15px' : '0'};
  box-shadow: ${props => props.isOpen ? '0 8px 25px rgba(0,0,0,0.15)' : 'none'};
  transition: width 0.3s ease, min-width 0.3s ease, max-width 0.3s ease,
              box-shadow 0.3s ease, border-radius 0.3s ease;
  align-self: flex-start;
  position: relative;

  @media (max-width: 1023px) {
    position: fixed;
    top: 0; left: 0; bottom: 0;
    width: ${props => props.isOpen ? '280px' : '0px'};
    min-width: 0;
    max-width: none;
    max-height: 100vh;
    border-radius: ${props => props.isOpen ? '0 15px 15px 0' : '0'};
    z-index: 100;
    align-self: auto;
  }
`;

const SidebarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px;
  border-bottom: 1px solid rgba(255,255,255,0.15);
`;

const SidebarTitle = styled.span`
  color: rgba(255,255,255,0.9);
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  white-space: nowrap;
`;

const SidebarCloseBtn = styled.button`
  background: rgba(255,255,255,0.1);
  border: none;
  color: white;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;

  &:hover { background: rgba(255,255,255,0.2); }

  @media (min-width: 1024px) {
    display: none;
  }
`;

const SidebarNav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 10px 11px;
  overflow-y: auto;
  max-height: calc(100vh - 70px);
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: rgba(255,255,255,0.05);
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(255,255,255,0.2);
    border-radius: 4px;
  }
`;

const SidebarItem = styled.a`
  display: flex;
  text-decoration: none;
  align-items: center;
  gap: 11px;
  padding: 9px 13px;
  background: rgba(255,255,255,0.08);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.25s ease;
  color: #ffffff;
  font-weight: 500;
  border: 1px solid rgba(255,255,255,0.08);
  white-space: nowrap;

  &:hover {
    background: rgba(255,255,255,0.18);
    transform: translateX(4px);
    box-shadow: 0 3px 10px rgba(0,0,0,0.15);
  }

  &:active { transform: translateX(2px); }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 21px;
  flex-shrink: 0;
  color: #ffffff;

  svg { width: 18px; height: 18px; }
`;

const ItemLabel = styled.span`
  font-size: 0.86rem;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
`;

const SidebarLinksSection = styled.div`
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid rgba(255,255,255,0.15);
`;

const SidebarLinksTitle = styled.div`
  display: flex;
  align-items: center;
  color: rgba(255,255,255,0.6);
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding: 4px 6px 8px 6px;
  white-space: nowrap;
`;

const SidebarLinkItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: rgba(255,255,255,0.9);
  background: rgba(255,255,255,0.06);
  border-left: 3px solid ${props => props.accentColor || '#20b2aa'};
  margin-bottom: 5px;

  &:hover {
    background: rgba(255,255,255,0.14);
    transform: translateX(3px);
  }
`;

const SidebarLinkText = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;

  span {
    font-size: 0.8rem;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  small {
    font-size: 0.62rem;
    opacity: 0.6;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

// ── Área de conteúdo ──────────────────────────────────────────────────────────
const ContentArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 0;
  overflow-x: hidden;
  min-height: calc(100vh - 140px);
  box-sizing: border-box;

  @media (max-width: 1023px) {
    width: 100%;
  }
`;

// Saudação com o nome de quem está logado à esquerda e data/hora à direita
const WelcomeMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  background: #ffffff;
  padding: 20px 24px;
  border-radius: 15px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  border: 1px solid rgba(0,128,128,0.2);
  border-left: 4px solid #008080;

  > div:first-child { min-width: 0; }

  h1 {
    font-size: 1.5rem;
    color: #004d4d;
    margin: 0 0 6px 0;
    font-weight: 700;
    word-break: break-word;

    @media (max-width: 768px) { font-size: 1.25rem; }
    @media (max-width: 480px) { font-size: 1.1rem; }
  }

  p {
    font-size: 0.9rem;
    color: #5f6f6f;
    font-weight: 400;
    margin: 0;

    @media (max-width: 480px) { font-size: 0.82rem; }
  }
`;

const DateBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: #f0fdfa;
  border: 1px solid rgba(0,128,128,0.2);
  border-radius: 10px;
  color: #004d4d;
  font-size: 0.85rem;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;

  @media (max-width: 480px) {
    white-space: normal;
    font-size: 0.78rem;
  }
`;

const DateTime = styled.span`
  padding-left: 8px;
  border-left: 1px solid rgba(0,128,128,0.25);
  font-variant-numeric: tabular-nums;
`;

// Logo à esquerda e, quando há compromissos hoje, a agenda numa coluna à direita
const HomeBody = styled.div`
  flex: 1;
  display: flex;
  gap: 20px;
  align-items: stretch;
  min-width: 0;

  @media (max-width: 1023px) {
    flex-direction: column;
  }
`;

const AgendaPanel = styled.aside`
  flex: 0 0 300px;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 15px;
  padding: 18px 16px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  border: 1px solid rgba(0,128,128,0.2);
  box-sizing: border-box;
  min-width: 0;
  max-height: calc(100vh - 260px);
  min-height: 480px;

  @media (max-width: 1023px) {
    order: -1;
    flex-basis: auto;
    max-height: none;
    min-height: 0;
  }
`;

const AgendaHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #004d4d;
  font-size: 1rem;
  font-weight: 700;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 2px solid rgba(0,128,128,0.15);
`;

const AgendaCount = styled.span`
  margin-left: auto;
  background: #20b2aa;
  color: white;
  font-size: 0.75rem;
  font-weight: 700;
  min-width: 22px;
  padding: 2px 7px;
  border-radius: 11px;
  text-align: center;
  box-sizing: border-box;
`;

const AgendaList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  min-height: 0;
  padding-right: 2px;
`;

const AgendaItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #f0fdfa;
  border: 1px solid rgba(32,178,170,0.35);
  border-left: 4px solid #008080;
  border-radius: 10px;
  padding: 10px 12px;
  cursor: pointer;
  min-width: 0;
  transition: box-shadow 0.15s ease, transform 0.15s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0,128,128,0.18);
    transform: translateY(-1px);
  }
`;

const AgendaHora = styled.span`
  flex-shrink: 0;
  padding: 2px 7px;
  border-radius: 6px;
  background: #008080;
  color: white;
  font-size: 0.8rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
`;

const AgendaItemBody = styled.div`
  flex: 1;
  min-width: 0;

  strong {
    display: block;
    font-size: 0.88rem;
    font-weight: 700;
    color: #004d4d;
    word-break: break-word;
  }

  .cliente {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-top: 3px;
    font-size: 0.8rem;
    font-weight: 600;
    color: #008080;
    word-break: break-word;
  }

  p {
    margin: 4px 0 0 0;
    font-size: 0.78rem;
    color: #34495e;
    white-space: pre-wrap;
    word-break: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

const AgendaDoneButton = styled.button`
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  margin: -2px -4px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #7f8c8d;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: rgba(231,76,60,0.12);
    color: #e74c3c;
  }
`;

const LogoSection = styled.div`
  background: white;
  border-radius: 15px;
  padding: 60px 24px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  text-align: center;
  border: 1px solid rgba(0,128,128,0.2);
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 480px;
  box-sizing: border-box;
  /* Logo próprio é desenhado por cima do cartão inteiro (LogoEnquadrado), recortado pelas bordas arredondadas */
  position: relative;
  overflow: ${props => (props.$personalizado ? 'hidden' : 'visible')};

  @media (max-width: 768px) {
    min-height: 300px;
    padding: 40px 16px;
  }

  @media (max-width: 480px) {
    min-height: 220px;
    padding: 30px 12px;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const LogoImage = styled.img`
  max-width: 600px;
  width: 100%;
  height: auto;
  object-fit: contain;

  @media (max-width: 768px) { max-width: 340px; }
  @media (max-width: 480px) { max-width: 220px; }
`;

// ── Links Úteis ───────────────────────────────────────────────────────────────
const LinksSection = styled.div`width: 100%;`;

const SectionTitle = styled.h2`
  color: #004d4d;
  font-size: 1.1rem;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  font-weight: 600;
  padding-bottom: 10px;
  border-bottom: 2px solid #008080;
`;

const LinksGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 14px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`;

const UsefulLinkCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  color: white;
  min-height: 60px;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 5px 15px rgba(0,0,0,0.2);
    filter: brightness(1.05);
  }
`;

const LinkContent = styled.div`flex: 1; min-width: 0;`;

const LinkTitle = styled.h3`
  margin: 0 0 4px 0;
  font-size: 0.88rem;
  font-weight: 600;
  color: white;
  text-shadow: 0 1px 2px rgba(0,0,0,0.2);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const LinkUrl = styled.p`
  margin: 0;
  font-size: 0.7rem;
  opacity: 0.85;
  color: white;
  word-break: break-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const LinkIcon = styled.div`
  margin-left: 10px;
  opacity: 0.8;
  flex-shrink: 0;
`;

// ── Modais ────────────────────────────────────────────────────────────────────
const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 22px;
  border-bottom: 1px solid #e9ecef;
  background: linear-gradient(135deg, #008080 0%, #20b2aa 100%);
  color: white;
  border-radius: 12px 12px 0 0;
  h2 { margin: 0; font-size: 1.3rem; display: flex; align-items: center; }
`;

const CloseButton = styled.button`
  background: none; border: none; color: white;
  font-size: 24px; cursor: pointer; padding: 4px;
  border-radius: 50%; width: 30px; height: 30px;
  display: flex; align-items: center; justify-content: center;
  &:hover { background: rgba(255,255,255,0.1); }
`;

const ModalContent = styled.div`
  padding: 24px;
  background: #fff;
  max-height: 70vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  @media (max-width: 480px) {
    padding: 16px;
  }
`;

const SecurityIcon = styled.div`
  display: flex; align-items: center; justify-content: center;
  width: 40px; height: 40px; border-radius: 50%;
  background-color: rgba(231,76,60,0.1);
`;

const PasswordRequirements = styled.div`
  background-color: #f8f9fa;
  padding: 15px; border-radius: 10px;
  margin-bottom: 20px;
  border-left: 4px solid #008080;
  h4 { font-size: 1rem; font-weight: 600; }
  ul { font-size: 0.88rem; li { margin-bottom: 5px; } }
`;

const FormField = styled.div`
  margin-bottom: 20px;
  label { display: block; margin-bottom: 8px; font-weight: 600; color: #2c3e50; }
`;

const ErrorMessage = styled.span`
  display: block; color: #e74c3c;
  font-size: 0.85rem; margin-top: 5px; font-weight: 500;
`;

const PasswordInput = styled.input`
  width: 100%; padding: 11px 14px;
  border: 2px solid ${props => props.hasError ? '#e74c3c' : '#ddd'};
  border-radius: 8px; font-size: 15px;
  transition: all 0.3s ease; box-sizing: border-box;
  &:focus {
    outline: none;
    border-color: ${props => props.hasError ? '#e74c3c' : '#008080'};
    box-shadow: 0 0 0 3px ${props => props.hasError ? 'rgba(231,76,60,0.1)' : 'rgba(0,128,128,0.1)'};
  }
  &::placeholder { color: #adb5bd; }
`;

const SubmitButton = styled.button`
  width: 100%; padding: 14px;
  background: linear-gradient(135deg, #008080 0%, #20b2aa 100%);
  color: white; border: none; border-radius: 8px;
  font-size: 1rem; font-weight: 600; cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0,128,128,0.3);
  &:hover { transform: translateY(-2px); box-shadow: 0 6px 20px rgba(0,128,128,0.4); }
`;

const ButtonContainer = styled.div`
  display: flex; justify-content: flex-end; margin-top: 10px;
`;

const modalRelatorioStyles = {
  overlay: { backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000 },
  content: {
    top: '50%', left: '50%', right: 'auto', bottom: 'auto',
    marginRight: '-50%', transform: 'translate(-50%,-50%)',
    maxWidth: '500px', width: '90%', borderRadius: '12px',
    padding: '0', border: 'none', boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
  }
};

const FormGroup = styled.div`margin-bottom: 20px;`;

const Label = styled.label`
  display: flex; align-items: center;
  margin-bottom: 8px; font-weight: 600; color: #2c3e50;
`;

const Input = styled.input`
  width: 100%;
  padding: 11px 14px;
  border: 2px solid #ddd;
  border-radius: 8px;
  font-size: 15px;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
  &:focus { outline: none; border-color: #008080; box-shadow: 0 0 0 3px rgba(0,128,128,0.1); }
`;

const ButtonGroup = styled.div`
  display: flex; gap: 12px; margin-bottom: 20px; flex-wrap: wrap;
`;

const FilterButton = styled.button`
  flex: 1;
  padding: 11px 18px;
  background: #f8f9fa;
  color: #2c3e50;
  border: 2px solid #dee2e6;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  min-width: 0;
  white-space: nowrap;
  &:hover { background: #e9ecef; }
`;

const ActionButton = styled.button`
  flex: 2;
  padding: 11px 18px;
  background: ${props => props.disabled ? '#6c757d' : 'linear-gradient(135deg, #008080 0%, #20b2aa 100%)'};
  color: white;
  border: none;
  border-radius: 8px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  min-width: 0;
  white-space: nowrap;
  opacity: ${props => props.disabled ? 0.6 : 1};
  &:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 4px 15px rgba(0,128,128,0.4); }
`;

const InfoText = styled.p`
  text-align: center; color: #6c757d; font-size: 13px; margin: 0;
  padding: 10px; background: #f8f9fa; border-radius: 6px;
  border-left: 4px solid #008080;
`;

export default Home;
